import { EmailTemplate } from '../../../clients/quipli-service/email/email';
import { Button } from '../../../components/form/button';
import Icon from '../../../components/icons/icon';
import { Modal } from '../../../components/modal/modal';
import { Typography } from '../../../components/typography/typography';

export const EmailTemplateModal = ({
  isOpen,
  close,
  selectedTemplate,
  isLoading,
  setIsLoading,
  update,
}: {
  isOpen: boolean;
  close: any;
  selectedTemplate: EmailTemplate | null;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  update: (template: EmailTemplate) => Promise<void>;
}) => (
  <Modal
    isOpen={isOpen}
    close={close}
    title="Are you sure you want to disable this email?"
    headerIcon={
      <div className="rounded-full p-3 bg-warning-100">
        <Icon icon="AlertTriangle" />
      </div>
    }
    actions={
      <>
        <Button className="button button-secondary" disabled={isLoading} onClick={close} dataCy="email-template-close">
          Cancel
        </Button>
        <Button
          className="button button-yellow"
          disabled={isLoading}
          onClick={async () => {
            if (!selectedTemplate) {
              return;
            }
            setIsLoading(true);
            await update({ ...selectedTemplate, enabled: !selectedTemplate.enabled });
            setIsLoading(false);
            close();
          }}
          dataCy="email-template-disable"
        >
          Disable for All {selectedTemplate?.userType}s
        </Button>
      </>
    }
  >
    <Typography type="text-sm" className="text-grey-600">
      This will prevent the email from being sent to{' '}
      <>
        <strong>all {selectedTemplate?.userType === 'Customer' ? 'customers.' : 'admin users.'}</strong>
        {selectedTemplate?.userType !== 'Customer' && (
          <>
            {' To disable it for specific users, adjust the '}
            <strong>Email Notifications</strong>
            {' in the '}
            <strong>Admin Users</strong>
            {' section.'}
          </>
        )}
      </>
    </Typography>
  </Modal>
);
